export const enum JourneyViewType {
    Inbound = "inbound",
    Outbound = "outbound",
}
